//= require_tree .

$(document).ready(function () {
  $("a.toggle, a.submenu-toggle").click(function (event) {
    event.preventDefault();
  });

  $("body > *:not(header)").click(function (event) {
    $(".main-menu").fadeOut().removeClass("active-menu");
    $(".submenu").fadeOut().removeClass("active-submenu");
  });

  $(".toggle").click(function () {
    var target = $(this).data("target");
    if ($(target).hasClass("active-menu")) {
      if ($(this).attr("id") == "mobile-menu-toggle") {
        $(".submenu").fadeOut().removeClass("active-submenu");
        $(".main-menu").fadeOut().delay(400).removeClass("active-menu");
      }
      return;
    }
    if ($(".main-menu").hasClass("active-menu")) {
      $(".submenu").fadeOut().removeClass("active-submenu");
      $(".main-menu").fadeOut().delay(400).removeClass("active-menu");
    }
    $(target).addClass("active-menu");
    $(target).fadeToggle();
  });

  $(".submenu-toggle").click(function () {
    var target = $(this).data("target");
    if ($(target).hasClass("active-submenu")) {
      return;
    }
    if ($(".submenu").hasClass("active-submenu")) {
      if ($(window).width() <= 480) {
        $(".submenu").fadeOut().removeClass("active-submenu");
      } else {
        $(".submenu").fadeOut().delay(400).removeClass("active-submenu");
      }
    }
    $(target).addClass("active-submenu");
    $(target).fadeIn();
  });

  $(".submenu-close").click(function () {
    var target = $(this).data("target");
    $(target).fadeOut().removeClass("active-submenu");
  });

  $("#hero").slick({
    autoplay: true,
    autoplaySpeed: 4000,
    swipe: false,
    dots: true,
    arrows: false,
    infinite: true,
    speed: 600,
    fade: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDots: false,
    cssEase: "ease-in",
    appendDots: $(".hero-dots"),
    dotsClass: "hero-dots",
  });

  $(".hero-carousel").slick({
    mobileFirst: true,
    slidesToShow: 1,
    swipe: true,
    swipeToSlide: true,
    draggable: true,
    dots: true,
    arrows: false,
    infinite: true,
    speed: 600,
    cssEase: "ease-in",
    appendDots: $(".hero-carousel-dots"),
    dotsClass: "hero-dots",
    responsive: [
      {
        breakpoint: 480,
        settings: {
          variableWidth: true,
        },
      },
    ],
  });

  $("#home-collection-slider").slick({
    slidesToShow: 3,
    variableWidth: true,
    infinite: true,
    appendArrows: $("#home-collection-slider-arrows"),
    prevArrow:
      "<button type='button' class='slick-prev f3 flex items-center justify-center bn br-100 bg-transparent pointer white'>←</button>",
    nextArrow:
      "<button type='button' class='slick-prev f3 flex items-center justify-center bn br-100 bg-transparent pointer white'>→</button>",
  });

  $("#materials-slider").slick({
    slidesToShow: 3,
    variableWidth: true,
    infinite: true,
    appendArrows: $("#materials-slider-arrows"),
    prevArrow:
      "<button type='button' class='slick-prev f3 flex items-center justify-center bn br-100 bg-transparent pointer'>←</button>",
    nextArrow:
      "<button type='button' class='slick-prev f3 flex items-center justify-center bn br-100 bg-transparent pointer'>→</button>",
  });

  $("#creator-work-slider").slick({
    slidesToShow: 3,
    variableWidth: true,
    infinite: true,
    appendArrows: $("#creator-work-slider-arrows"),
    prevArrow:
      "<button type='button' class='slick-prev f3 flex items-center justify-center bn br-100 bg-transparent pointer black'>←</button>",
    nextArrow:
      "<button type='button' class='slick-prev f3 flex items-center justify-center bn br-100 bg-transparent pointer black'>→</button>",
  });

  $("#fabrics-slider").slick({
    slidesToShow: 3,
    variableWidth: true,
    infinite: true,
    appendArrows: $("#fabrics-slider-arrows"),
    prevArrow:
      "<button type='button' class='slick-prev f3 flex items-center justify-center bn br-100 bg-transparent pointer white'>←</button>",
    nextArrow:
      "<button type='button' class='slick-prev f3 flex items-center justify-center bn br-100 bg-transparent pointer white'>→</button>",
  });

  $("#rooms-slider").slick({
    slidesToShow: 8,
    infinite: true,
  });

  settings = {
    mobileFirst: true,
    autoplay: true,
    autoplaySpeed: 4000,
    swipe: true,
    dots: false,
    arrows: false,
    infinite: true,
    speed: 600,
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDots: false,
    cssEase: "ease-in-out",
    centerMode: true,
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 480,
        settings: "unslick",
      },
    ],
  };

  $sliders = $(
    "#creators-slider, #collections-slider, #interesting-slider, #materials-and-fabrics-slider, #professionals-slider"
  );

  $sliders.slick(settings);

  window.addEventListener("load", function () {
    if ($(window).width() <= 480) {
      var menuHeight = $("#navbar").outerHeight(true) + "px";
      if (!$(".main-menu").hasClass("is-mobile"))
        $(".main-menu").addClass("is-mobile");
      $(".main-menu").css("top", menuHeight);
    }
  });

  $(window).resize(function () {
    if ($(window).width() >= 480) {
      if ($sliders.hasClass("slick-initialized")) $sliders.slick("unslick");

      if ($(".main-menu").hasClass("is-mobile")) {
        console.log("Is not mobile!");
        $(".main-menu").css("top", "");
        $(".main-menu").removeClass("is-mobile");
      }

      return;
    }
    if (!$sliders.hasClass("slick-initialized"))
      return $sliders.slick(settings);

    var menuHeight = $("#navbar").outerHeight(true) + "px";
    if ($(window).width() <= 480) {
      if (!$(".main-menu").hasClass("is-mobile"))
        $(".main-menu").addClass("is-mobile");
      $(".main-menu").css("top", menuHeight);
    }
  });

  var title = $(this).find(".slick-active").data("title");
  $("#collection-title").text(title);

  var author = $(this).find(".slick-active").data("author");
  $("#collection-author").text(author);

  $("#hero").on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      $("#collection").fadeTo(300, 0);
    }
  );

  $("#hero").on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var title = $(this).find(".slick-current").data("title");
      $("#collection-title").text(title);
      var author = $(this).find(".slick-current").data("author");
      $("#collection-author").text(author);
      $("#collection").fadeTo(200, 1);
    }
  );

  $(".accordion").accordion({
    heightStyle: "content",
    collapsible: true,
    active: false,
  });

if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
  $(".letter")
    .mouseenter(function () {
      $(this).next(".letter-images").fadeIn("fast");
      $(this).addClass("z-5").siblings().removeClass("z-5");
    })
    .mouseleave(function () {
      $(this).next(".letter-images").fadeOut("fast");
    });
}


                      $(window).scroll(function () {
                          if ($(window).scrollTop() > 32) {
                                $(".logo").addClass("w-50");
                                      $(".logo").removeClass("w-100");
                                          } else if ($(window).scrollTop() < 1) {
                                                $(".logo").addClass("w-100");
                                                      $(".logo").removeClass("w-50");
                                                          }
                                                              if ($(window).width() <= 480) {
                                                                    var menuHeight = $("#navbar").outerHeight(true) + "px";
                                                                          if (!$(".main-menu").hasClass("is-mobile"))
                                                                                  $(".main-menu").addClass("is-mobile");
                                                                                        $(".main-menu").css("top", menuHeight);
    }
  });
});
